module.exports = __webpack_public_path__ + "img/signup-bg.6fe02d64.png";